const FK_COINS_TOOLTIP_PREFIX = "fk-coins-tooltip";

export const FLIPKART_SUPERCOINS_TOOLTIP_TEST_IDS = {
    TURBO: `${FK_COINS_TOOLTIP_PREFIX}_turbo`,
    PAYMENT: `${FK_COINS_TOOLTIP_PREFIX}_payment`,
};
